let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iWvkj")).then(() => parcelRequire('etwfl'));